import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable, ReplaySubject } from "rxjs";

import { PerfilRole } from "../Entities/Perfil/perfilRole.entity";
import { Opcion } from "../Entities/Rol/opcion.entity";
import { Rol } from "../Entities/Rol/rol.entity";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class RolesRepository {
  private opciones: ReplaySubject<Opcion[]>;
  private roles: ReplaySubject<Rol[]>;
  private readonly rolesFiduciaria: ReplaySubject<Rol[]>;

  constructor(private http: HttpClient) {}

  //GET
  getRoles(overwrite = false): Observable<Rol[]> {
    if (!this.roles || overwrite) {
      if (!this.roles) this.roles = new ReplaySubject(1);

      this.http.get<Rol[]>(`${enlineaBackendUrl}/api/Roles?spinner=true`).subscribe((results) => {
        this.roles.next(results);
      });
    }

    return this.roles;
  }

  public getRolesFiduciaria(overwrite = false): Observable<Rol[]> {
    return this.http.get<Rol[]>(`${enlineaBackendUrl}/api/FiduciariaRoles/ObtenerRoles?spinner=true`);
  }

  GetRolesByPerfilId(id): Observable<PerfilRole[]> {
    return this.http.get<PerfilRole[]>(`${enlineaBackendUrl}/api/Perfil/ObtenerRol/${id}`);
  }
  getOpciones(overwrite = false): Observable<Opcion[]> {
    if (!this.opciones || overwrite) {
      if (!this.opciones) this.opciones = new ReplaySubject(1);

      this.http.get<Opcion[]>(`${enlineaBackendUrl}/api/Roles/ObtenerOpciones`).subscribe((results) => {
        this.opciones.next(results);
      });
    }

    return this.opciones;
  }

  //POST
  saveRol(rol: Rol): Observable<Rol> {
    return this.http.post<Rol>(`${enlineaBackendUrl}/api/Roles`, rol);
  }

  //PATCH
  updateRol(rol: Rol): Observable<any> {
    return this.http.patch(`${enlineaBackendUrl}/api/Roles`, rol);
  }

  //DELETE
  deleteRol(rol: Rol): Observable<any> {
    return this.http.delete(`${enlineaBackendUrl}/api/Roles/${rol.id}`);
  }
}
